import React, {useState} from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import './TrendsTable.scss'
import utils from "../../../utils/utils.json"

function TrendsTable({sign, colorPrice, columns, keyInter, data, handleClickTicker}) {

  const changeTypes = {
    percentage: "%",
    currency: "$"
  }

  const [changeType, setChangeType] = useState(changeTypes.percentage);

  const onChangeType = () => {
    if (changeType === changeTypes.currency) {
      setChangeType(changeTypes.percentage)
    } else {
      setChangeType(changeTypes.currency)
    }
  }

  function formattingValue(column, value, row) {
    const isCurrency = changeType === changeTypes.currency;
    const changeKey = isCurrency ? "changeAmount" : "changePercentage";
    
    const stringChange = String(row[changeKey] || "");
    const numericString = stringChange.replace(/[%$]/g, '').trim();
    const formattedChangeValue = !isNaN(numericString) && numericString !== "" ? Number(numericString).toFixed(2) : stringChange;
    
    const formattedChange = `${sign === utils.plus ? utils.plus : ""}${formattedChangeValue}${isCurrency ? " $" : "%"}`;

    const isNumeric = ["price", "change", "changePercentage", "changeAmount", "volume"].includes(column.label);

    const tableCellProps = {
      onClick: column.label === "change" ? () => onChangeType() : () => handleClickTicker(row["ticker"]),
      className: `tableCell ${column.label === "ticker" ? "ticker" : ""} ${isNumeric ? "numeric-cell" : ""}`,
      sx: {
        border: "0",
      },
      style: column.label === "change" ? { cursor: "pointer" } : {},
      key: column.label,
      align: column.align || (isNumeric ? "right" : "inherit"),
      id: column.label
    };

    if (column.label === "ticker") {
      return (
          <>
              <TableCell {...tableCellProps} className={`${tableCellProps.className} ticker-name`}>
                  {row.name || value}
              </TableCell>
              <TableCell {...tableCellProps} className={`${tableCellProps.className} ticker-only`}>
                  {value}
              </TableCell>
          </>
      );

    } else if (column.label === "change") {
      const backgroundColor = colorPrice.includes('rgb') 
        ? colorPrice.replace('rgb', 'rgba').replace(')', ', 0.1)') 
        : colorPrice + "1A";

      return (
        <TableCell {...tableCellProps}>
          <span 
            key={changeType} 
            className="gain-loss-pill animate-flip" 
            style={{ color: colorPrice, backgroundColor }}
          >
            {formattedChange}
          </span>
        </TableCell>
      );

    } else if (column.label === "price") {
      const formattedPrice = !isNaN(value) && value !== null ? Number(value).toFixed(2) : value;
      return (
        <TableCell {...tableCellProps}>
          {`${formattedPrice} $`}
        </TableCell>
      );

    } else {
      return (
        <TableCell {...tableCellProps}>
          {value}
        </TableCell>
      );
    }
  }


  return (
    <div className={"tableTrends"}>
      <Paper className={"paper"} sx={{width: '100%', overflow: 'visible', boxShadow: 0, borderRadius: "15px", background: 'transparent'}}>
        <TableContainer className={"tableContainer"} sx={{overflow: 'visible'}}>
          <Table stickyHeader aria-label="sticky table">
            <TableBody className={"tableRow"}>
              {data.map((row, rowIndex) => (
                <TableRow hover role="checkbox" tabIndex={-1} key={row.id || rowIndex}>
                  {columns.map((column) => {
                    const value = row[column.label];
                    return (
                      formattingValue(column, value, row)
                    );
                  })}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </div>

  );
}

export default TrendsTable;
